<template>
  <div>

    <b-form @submit.prevent="save">

        <vs-divider class="m-1"> 1º Período </vs-divider>

        <div class="vx-row">

          <div class="vx-col sm:w-1/2 w-full mb-2">

            <b-form-group
              label="Início"
              label-for="period1-start-at"
            >
              <validation-provider
                #default="{ errors }"
                name="period1-start-at"
              >
                <flat-pickr
                  v-model="period1.start_at"
                  class="form-control"
                  :config="{ enableTime: true, noCalendar: true, dateFormat: 'H:i',}"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

          </div>

          <div class="vx-col sm:w-1/2 w-full mb-2">

            <b-form-group
              label="Fim"
              label-for="period1-finish_at"
            >
              <validation-provider
                #default="{ errors }"
                name="period1-finish_at"
              >
                <flat-pickr
                  v-model="period1.finish_at"
                  class="form-control"
                  :config="{ enableTime: true, noCalendar: true, dateFormat: 'H:i',}"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

          </div>

        </div>

        <vs-divider class="m-1"> 2º Período </vs-divider>

        <div class="vx-row">

          <div class="vx-col sm:w-1/2 w-full mb-2">

            <b-form-group
              label="Início"
              label-for="period2-start-at"
            >
              <validation-provider
                #default="{ errors }"
                name="period2-start-at"
              >
                <flat-pickr
                  v-model="period2.start_at"
                  class="form-control"
                  :config="{ enableTime: true, noCalendar: true, dateFormat: 'H:i',}"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

          </div>

          <div class="vx-col sm:w-1/2 w-full mb-2">

            <b-form-group
              label="Fim"
              label-for="period2-finish_at"
            >
              <validation-provider
                #default="{ errors }"
                name="period2-finish_at"
              >
                <flat-pickr
                  v-model="period2.finish_at"
                  class="form-control"
                  :config="{ enableTime: true, noCalendar: true, dateFormat: 'H:i',}"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

          </div>

        </div>

        <div class="vx-row">
          <div class="vx-col w-full">
            
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-5 mr-2 float-right"
              type="submit"
            >
              Salvar
            </b-button>
            
          </div>
        </div>

    </b-form>

  </div>
</template>

<script>
import {
  BForm, BButton, BFormGroup, BInputGroup
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    flatPickr,
    BForm,
    BButton,
    BFormGroup,
    BInputGroup,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    services: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    period1: {
      start_at: null,
      finish_at: null
    },
    period2: {
      start_at: null,
      finish_at: null
    },
    dateFormat: 'dd/MM/yyyy',
    id: null,
    parentEntity: null,
  }),
  computed: {
    
  },
  watch: {},
  methods: {
    save() {
      this.clearErrors(this.$validator)
      this.$vs.loading()

      const params = {
        natural_entity_id: this.parentEntity.id,
        period1_start_at: this.period1.start_at,
        period1_finish_at: this.period1.finish_at,
        period2_start_at: this.period2.start_at,
        period2_finish_at: this.period2.finish_at,
      }

      this.services.workingTimeService.createOrUpdate(params).then(
        data => {
          this.$vs.loading.close()
          this.notifySuccess(this.$vs)
        },
        error => {
          this.$vs.loading.close()
          this.showErrors(this.$validator, error)
        }
      )
    }
  },
  beforeMount() {
    this.$vs.loading()
    
  },
  mounted() {
    this.$root.$on('naturalEntityUpdated', () => {
      this.parentEntity = this.$store.getters['naturalEntity/naturalEntity']

      if (this.parentEntity.working_times && this.parentEntity.working_times.length > 0) {
        const workingTime = this.parentEntity.working_times[0]
        this.period1.start_at = workingTime.period1_start_at
        this.period1.finish_at = workingTime.period1_finish_at
        this.period2.start_at = workingTime.period2_start_at
        this.period2.finish_at = workingTime.period2_finish_at
      }
    })
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>